import React, { forwardRef } from 'react';
import { UploadOutlined } from '@aelf-design/icons';
import { useTheme } from 'antd-style';
import useStyles from "./style";
var UploadButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var uploadIconColor = props.uploadIconColor,
    uploadText = props.uploadText,
    tips = props.tips,
    className = props.className,
    style = props.style;
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;
  var token = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: cx(prefixCls + '-upload-button', styles.uploadButton, className),
    style: style,
    ref: ref
  }, /*#__PURE__*/React.createElement(UploadOutlined, {
    style: {
      fontSize: 40
    },
    color: uploadIconColor || token.colorPrimary
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.uploadText
  }, uploadText || 'Upload'), tips || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.messageTitle
  }, "Formats supported JPG, JPEG, PNG. Max size 100MB.", "Recommend ratio 16:9."))));
});
UploadButton.displayName = 'UploadButton';
export default UploadButton;